"use client";

import { User } from "lucide-react";
import { useEffect, useState } from "react";
import { apiFetch } from "../lib/api";

export function HeaderAuthButton() {
  const [state, setState] = useState({ loading: true, user: null });

  useEffect(() => {
    let active = true;

    apiFetch("/api/v1/auth/me", { cache: "no-store", timeoutMs: 6000 })
      .then((data) => {
        if (active) setState({ loading: false, user: data.user || null });
      })
      .catch(() => {
        if (active) setState({ loading: false, user: null });
      });

    return () => {
      active = false;
    };
  }, []);

  const pilotName = pilotDisplayName(state.user);

  if (pilotName) {
    return (
      <a className="nitro-primary-button login-button header-user-button" href="/perfil" title={`Ir al perfil de ${pilotName}`}>
        <User size={17} />
        <span>{pilotName}</span>
      </a>
    );
  }

  return (
    <a className="nitro-primary-button login-button" href="/login">
      <User size={17} />
      <span>{state.loading ? "Entrar / Registro" : "Entrar / Registro"}</span>
    </a>
  );
}

function pilotDisplayName(user) {
  if (!user) return "";

  const pilot = user.pilot || {};
  const fullName = [pilot.firstName || user.firstName, pilot.lastName || user.lastName].filter(Boolean).join(" ").trim();
  return pilot.displayName || user.displayName || fullName || user.email || "";
}
